import { isPromotionHitted } from '@/api/cashier'
const state = () => ({
  promotionList: [],
  promotionSelect: null,
})
const getters = {
  promotionList: (state) => state.promotionList,
  promotionSelect: (state) => state.promotionSelect,
}
const mutations = {
  SET_PROMOTION_LIST(state, promotionList) {
    state.promotionList = promotionList
    if (promotionList.length) return (state.promotionSelect = promotionList[0])
    state.promotionSelect = null
  },
  SET_PROMOTION_SELECT(state, promotionSelect) {
    state.promotionSelect = promotionSelect
  },
  REMOVE_PROMOTION_LIST(state) {
    state.promotionList = []
    state.promotionSelect = null
  },
}

const actions = {
  removePromotionList({ commit }) {
    commit('REMOVE_PROMOTION_LIST')
  },
  setPromotionSelect({ commit }, promotionSelect) {
    commit('SET_PROMOTION_SELECT', promotionSelect)
  },
  async fetchPromotionList({ commit }, payload) {
    let { data } = await isPromotionHitted(payload, payload.usePromotionUid || false)
    if (data.isHitted && data.items.length) return commit('SET_PROMOTION_LIST', data.items)
    commit('SET_PROMOTION_LIST', [])
  },
}

export default { state, getters, mutations, actions }
